// extracted by mini-css-extract-plugin
module.exports = {"new-ticket-layout":"newTicket_new-ticket-layout__u4qsZ","upload-btn":"newTicket_upload-btn___552R","submit-btn":"newTicket_submit-btn__sfTfk","active":"newTicket_active__slVNd"};